import React from 'react';
import './MainResult.css';

const CategoryNav = ({ categories, selectedCategory, onCategorySelect }) => {
  return (
    <div className="result-header">
      <div className="header-nav">
        {categories.map((category, index) => (
          <div
            key={category.name}
            className={`nav-item ${category.active ? 'active' : ''}`}
            onClick={() => onCategorySelect(index)}
          >
            {category.name && <span className="nav-name">↗ {category.name}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryNav;

